const SDK_VERSION = '7.102.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
